import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Style from '../Styles/Common.module.css';
import BreadcrumbComponent from "../Common/CommonSections/Breadcrum";
import { Link } from "react-router-dom";

const RefundPolicyPage = ()=>{
    return(
        <div>
            <BreadcrumbComponent home='Home' listOne="Refund Policy" />
            <div className={Style.pageTitle + ' ' + Style.marginUp40 + ' ' + Style.disclaimerPage}>
                <Container>
                    <Row>
                        <Col>
                            <div className={Style.sectionTitle}>
                                <h2>Refund Policy</h2>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className={Style.aboutmayocollege + ' ' + Style.pageBoder}>
                                <p>At Mayo College Alumni Association Delhi, we aim to provide a seamless and satisfying experience for our Mayo Alumni. Please review our refund policy outlined below:</p>
                                <h3>Eligibility:</h3>
                                <p>Refunds will be considered for events and services paid for by members or participants. Refund requests must be made within 30 days of the date of the transaction.</p>
                                <h3>Event Registration Refunds:</h3>
                                <p>Refunds for event registration fees will be issued only if the cancellation is made before the specified deadline.</p>
                                <p>Late cancellations may be considered on a case-by-case basis, subject to approval by the Mayo College Alumni Association Delhi.</p>
                                <h3>Membership Fees:</h3>
                                <p>Membership fees are non-refundable.</p>
                                <h3>Processing Time:</h3>
                                <p>Refund processing may take up to 15 days from the date of the approved request.</p>
                                <h3>Refund Procedure:</h3>
                                <p>To request a refund, please submit a written request to <a href="mailto:secretary@mayoalumni.in">secretary@mayoalumni.in</a>
                                with the subject line "Refund Request - [Event/Service Name]."</p>
                                <p>Include the following details in your refund request:</p>
                                <ul>
                                    <li>Full Name</li>
                                    <li>Transaction ID</li>
                                    <li>Event/Service Name</li>
                                    <li>Reason for Refund</li>
                                    <li>Any supporting documentation</li>
                                </ul>
                                <h3>Denied Refunds:</h3>
                                <p>The Mayo College Alumni Association Delhi reserves the right to deny refund requests based on the circumstances of the request</p>
                                <h3>Contact Information:</h3>
                                <p>For any questions or concerns regarding refunds, please contact Ms Cini Suresh at <strong><Link to="mailto:secretary@mayoalumni.in">secretary@mayoalumni.in</Link> or <Link to='tel:9643558683'>9643558683</Link></strong>.</p>
                                <h3>Modification of Refund Policy:</h3>
                                <p>The Mayo College Alumni Association Delhi reserves the right to modify this refund policy at any time. Any changes will be effective immediately upon posting the revised policy on our website.</p>
                                <p>By participating in events or services offered by Mayo College Alumni Association, members and participants acknowledge and agree to abide by this refund policy.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}

export default RefundPolicyPage;